<template>
    <ValidationObserver
      ref="feature"
      v-slot="{ errors }"
      name="feature"
      tag="div"
    >
      <div
        class="d-flex justify-space-between px-0"
        :class="{
          'flex-column': isBookingFormNarrow,
          'align-items-center': !isBookingFormNarrow,
          'pb-4': !(errors.counter && errors.counter.length) && !(!(errors.counter && errors.counter.length) && isHintShow)
            && !isBookingFormNarrow,
          'pb-6': !(errors.counter && errors.counter.length) && !(!(errors.counter && errors.counter.length) && isHintShow)
            && isBookingFormNarrow,
        }"
      >
        <div
          class="d-flex body-2 p-0 left-column"
          :class="{ 'pb-3': isBookingFormNarrow }"
        >
          <div class="mr-2">
            <img
              v-if="icon !== 'mdi-wheelchair-accessibility'"
              class="feature-logo"
              :class="{ 'feature-logo--show': showIcon }"
              :src="`data:image/svg+xml;base64,${icon}`"
              :alt="$t('imageAlt.featureIcon', { name })"
              @load="showIcon = true"
            >
            <VIcon v-else>
              {{ icon }}
            </VIcon>
          </div>
          <div>
            <div>
              <span class="body-1">{{ name }}</span>
            </div>
            <div>
              <span
                v-if="price"
                class="body-2"
              >{{ amount }} x {{ price }}.00$ = {{ sumPrice }}.00$</span>
            </div>
          </div>
        </div>
        <VSpacer />
        <CustomCounter
          :dataTest="dataTest"
          :amount="amount"
          :maxValue="maxValue"
          :hint="$t('bookingForm.validations.maximumIsReached', { value: maxValue })"
          :rules="{ amountIsValid: [amount, maxValue] } "
          @updateAmount="updateAmount"
        />
      </div>
      <div 
        v-if="errors.counter && errors.counter.length"
        :data-test="`amountInvalid${dataTest}Error`"
        class="mt-0 pb-4 pt-1"
        :class="!isBookingFormNarrow && 'pl-8'"
      >
        <span class="caption error--text">{{ $t(errors.counter[0], {  feature: name, value: maxValue  }) }}</span>
      </div>
      <div
        v-if="!(errors.counter && errors.counter.length) && isHintShow"
        :data-test="`maxAmountIsReached${dataTest}`"
        class="d-flex flex-column mt-0 pb-4 pt-1"
        :class="!isBookingFormNarrow && 'pl-8'"
      >
        <span 
          v-if="isMaxValueReached" 
          class="caption textTertiary--text"
        >
          {{ $t('bookingForm.validations.maximumIsReached', { value: maxValue }) }}
        </span>
        <span 
          v-if="isWheelchairPlacesHint"
          class="caption textTertiary--text"
        >
          {{ $t('bookingForm.hints.wheelchairCapacity') }}
        </span>
      </div>
    </ValidationObserver>
</template>

<script lang="ts">
export default {
  name: 'FeatureItem',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CustomCounter from '@slg/web-customer-shared/src/components/common/CustomCounter.vue';
import SConstants from '@slg/web-customer-shared/src/utils/constants';
import { useVuetify } from '../../../composables';

const props = defineProps({
  icon: {
    type: String,
    default: 'mdi-help',
  },
  name: {
    type: String,
    default: '',
  },
  featureId: {
    type: String,
    default: '',
  },
  amount: {
    type: Number,
    default: null,
  },
  passengersAmount: {
    type: Number,
    default: null,
  },
  maxValue: {
    type: Number,
    default: 0,
  },
  price: {
    type: Number,
    default: 0,
  },
  dataTest: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['setFeatureAmount']);
const vuetify = useVuetify();
const showIcon = ref(false);
const feature = ref<InstanceType<typeof CustomCounter> | HTMLElement | { validate: () => void } | null>(null);

const sumPrice = computed(() => props.amount * props.price);
const isBookingFormNarrow = computed(() => vuetify?.breakpoint.smAndDown);
const isMaxValueReached = computed(() => props.amount === props.maxValue);
const isWheelchairPlaceFeature = computed(() => props.featureId === SConstants.WHEELCHAIR_PLACE_ID);
const isWheelchairPlacesHint = computed(() => isWheelchairPlaceFeature.value && props.amount > 0);
const isHintShow = computed(() => isMaxValueReached.value || isWheelchairPlacesHint.value);

function updateAmount(newValue: number) {
  const featurePayload = { vehicleFeatureId: props.featureId, amount: newValue };
  emit('setFeatureAmount', featurePayload);
  (feature.value as { validate: () => void }).validate();
}
</script>
<style lang="scss" scoped>
.left-column {
}
.feature-logo {
  width: 24px;
  height: 24px;
  opacity: 0;

  &--show {
    opacity: 1;
  }
}
</style>
